var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 15.0234H14.9997V6.82131L9.99967 2.27585L4.99967 6.82131V15.0234ZM15.833 16.6901H4.16634C3.70611 16.6901 3.33301 16.317 3.33301 15.8568V8.35675H0.833008L9.43909 0.53302C9.75692 0.24407 10.2424 0.24407 10.5603 0.53302L19.1663 8.35675H16.6663V15.8568C16.6663 16.317 16.2933 16.6901 15.833 16.6901ZM6.66634 7.52342C9.88801 7.52342 12.4997 10.1351 12.4997 13.3568H10.833C10.833 11.0556 8.96751 9.19009 6.66634 9.19009V7.52342ZM6.66634 10.8568C8.04705 10.8568 9.16634 11.976 9.16634 13.3568H6.66634V10.8568Z",
    fill: "#211E3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/Home_Icon.40e31ba623e6b29ca414a69514c7f953.svg";
export { ForwardRef as ReactComponent };